<script>
	/** @type {import('./$types').PageData} */
	export let data;
	/** @type {Object} article */
	let { article } = data;
	import Title from '$lib/components/article/Title.svelte';
	import AboutArticle from '$lib/components/article/AboutArticle.svelte';
	import HighwirePressTags from '$lib/components/article/HighwirePressTags.svelte';
</script>

<HighwirePressTags articleData={article} />

<svelte:head>
	<meta name="dc.identifier" content="doi:{article.doi}" />
	<meta name="dc.title" content={article.title} />
	{#if article.authors && article.authors.length > 0}
		<meta
			name="dc.creator"
			content={article.authors
				.map((author) => `${author.first_name} ${author.last_name}`)
				.join(', ')}
		/>
	{/if}
	<meta name="dc.subject" content={article.keywords} />
	<meta name="dc.description" content={article.abstract} />
	<meta name="dc.publisher" content="Dublin Core Metadata Initiative" />
	<meta name="dc.date" content={article.published_date} />
	<title>{article.title}</title>
</svelte:head>

<Title
	draft={article.draft || false}
	title={article.title}
	section={article.section.title}
	abstract={article.abstract}
	authors={article.authors}
	scopus_id={article.scopus_id}
	wikidata_id={article.wikidata_id}
	id={article.id}
	doi={article.doi}
	abstract_only={article.abstract_only}
/>

<div class="px-8 py-12 bg-white lg:px-8">
	<div class="max-w-5xl mx-auto text-base leading-7 text-gray-700">
		{#if article.abstract}
			<div class="text-lg font-semibold">Abstract</div>
			<p class="mt-6 leading-8 text-md">
				{article.abstract}
			</p>
		{/if}
	</div>
</div>

<div class="px-6 py-12 bg-white lg:px-8">
	<div class="max-w-5xl mx-auto text-base leading-7 text-gray-700">
		<AboutArticle {article} />
	</div>
</div>
